var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canDeliver)?_c('v-btn',{attrs:{"color":"primary","small":"","outline":"","loading":_vm.loading},on:{"click":_vm.deliver}},[_vm._v("\n       "+_vm._s(_vm.$t('deliver'))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }